var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNohoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 49,
    viewBox: "0 0 183 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.732 32.5396C175.718 32.5396 183.002 25.2553 183.002 16.2698C183.002 7.28423 175.718 0 166.732 0C157.747 0 150.463 7.28423 150.463 16.2698C150.463 25.2553 157.747 32.5396 166.732 32.5396Z",
    fill: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.649 32.5396H166.73V0H0V48.7667H162.649V32.5396Z",
    fill: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6285 20.8324V39.952H8.81396V8.81445H18.8569L31.5758 25.4347V8.81445H40.1709V39.952H32.6273L17.6285 20.8324Z",
    fill: "#EFEAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.389 24.3832C45.389 14.5597 52.7131 8.28711 62.0977 8.28711C71.4822 8.28711 78.8063 14.5597 78.8063 24.3832C78.8063 34.2066 71.4822 40.4792 62.0977 40.4792C52.7131 40.4792 45.389 34.0755 45.389 24.3832ZM69.687 24.3832C69.687 19.8235 66.8372 16.2696 62.1007 16.2696C57.3642 16.2696 54.5144 19.8204 54.5144 24.3832C54.5144 28.9459 57.3642 32.4967 62.1007 32.4967C66.8372 32.4967 69.687 28.9459 69.687 24.3832Z",
    fill: "#EFEAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.303 28.2876H93.0138V39.952H84.0225V8.81445H93.0138V20.4788H106.303V8.81445H115.294V39.952H106.303V28.2876Z",
    fill: "#EFEAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.512 24.3832C120.512 14.5597 127.836 8.28711 137.221 8.28711C146.605 8.28711 153.93 14.5597 153.93 24.3832C153.93 34.2066 146.605 40.4792 137.221 40.4792C127.836 40.4792 120.512 34.0755 120.512 24.3832ZM144.81 24.3832C144.81 19.8235 141.96 16.2696 137.224 16.2696C132.487 16.2696 129.638 19.8204 129.638 24.3832C129.638 28.9459 132.487 32.4967 137.224 32.4967C141.96 32.4967 144.81 28.9459 144.81 24.3832Z",
    fill: "#EFEAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.473 13.0239H166.732V6.52881L156.99 19.519H166.732V26.0111L176.473 13.0239Z",
    fill: "#CEDC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 48.7667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNohoLogo);
export default __webpack_public_path__ + "static/media/NOHO-logo.22ef0967b863cfec421b656e71259556.svg";
export { ForwardRef as ReactComponent };